import { LessonStatus } from '../api/mylb/enums/lesson-status.enum';
import { IEnrollmentDetailItem, ILessonListItem, IProgramSummary, LessonTypeCount } from '@lb/api/mylb/interfaces';

/**
 * Derives an IProgramSummary from enrollment detail and its associated lessons.
 * Returns undefined when the detail or its program summaries are not yet loaded.
 */
export function computeProgramSummary(detail: IEnrollmentDetailItem | null, lessons: ILessonListItem[]): IProgramSummary | undefined {
	const programSummaries = detail?.programSummaries;

	if (!detail || !programSummaries) return undefined;

	const lessonCounts: LessonTypeCount[] = lessons.reduce((acc, lesson) => {
		if (acc.find((lc: any) => lc.lessonTypeID === lesson.lessonTypeID)) {
			return acc;
		}

		const totalForType = lessons.filter((l) => l.lessonTypeID === lesson.lessonTypeID).length;
		const completedForType = lessons.filter((l) => l.lessonTypeID === lesson.lessonTypeID && l.lessonStatusID === LessonStatus.Completed).length;
		const expectedForType = totalForType > 0 ? totalForType : programSummaries.reduce((sum, ps) => sum + ps.lessonCount, 0);

		acc.push({
			lessonTypeID: lesson.lessonTypeID,
			lessonTypeName: lesson.lessonTypeName,
			totalLessons: totalForType,
			completedLessons: completedForType,
			expectedLessons: expectedForType
		});
		return acc;
	}, [] as LessonTypeCount[]);

	return {
		programID: detail.programID,
		programName: detail.programName,
		enrollmentID: detail.enrollmentID,
		languageID: detail.languageID,
		languageName: detail.languageName,
		learnerUserID: detail.learnerUserID,
		programTypeID: detail.programTypeID,
		programTypeName: detail.programTypeName,
		lessonCounts
	};
}
